var cilArrowThickToBottom = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M336,176.005V16H176v160H56v38.623l199.8,200L456,214.637V176.005ZM255.826,369.376,94.616,208.005H208V48h96v160H417.361Z' class='ci-primary'/><rect width='400' height='32' x='56' y='464' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickToBottom };

